import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {PageNotFoundComponent} from './shared/components/page-not-found/page-not-found.component';
import {RoutesEnum} from './core/services/navigation/routes.enum';
import {HomeRoutingModule} from './pages/home/home-routing.module';
import {AuthenticationRoutingModule} from './pages/authentication/authentication-routing.module';
import {UserRoutingModule} from './pages/user/user-routing.module';
import {SensorRoutingModule} from './pages/sensor/sensor-routing.module';
import {BoxRoutingModule} from './pages/box/box-routing.module';
import {PatientRoutingModule} from './pages/patient/patient-routing.module';
import {SettingsRoutingModule} from './pages/settings/settings-routing.module';
import {HealthCenterRoutingModule} from './pages/health-center/health-center-routing.module';

const routes: Routes = [
  {path: '', redirectTo: RoutesEnum.AUTHENTICATION, pathMatch: 'full'},
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {enableTracing: true}),
    AuthenticationRoutingModule,
    HomeRoutingModule,
    UserRoutingModule,
    SensorRoutingModule,
    BoxRoutingModule,
    PatientRoutingModule,
    SettingsRoutingModule,
    HealthCenterRoutingModule
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
